import { Flex } from "flux";

interface BulkGenerationFormProps {
  onFileSelect: (file: File) => void;
}

const BulkGenerationForm: React.FC<BulkGenerationFormProps> = ({ onFileSelect }) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileSelect(file);
    }
  };

  return (
    <Flex flexDirection="column">
      <Flex flexDirection="row" py="10px">
        <input id="input=file" name="file" required={true} type="file" accept=".csv" onChange={handleFileChange} />
      </Flex>
    </Flex>
  );
};

export default BulkGenerationForm;
